export default __webpack_public_path__ + "static/media/6.75751724.jpg";